import { render } from "./EditHuviring.vue?vue&type=template&id=2cee6809&scoped=true"
import script from "./EditHuviring.vue?vue&type=script&lang=js"
export * from "./EditHuviring.vue?vue&type=script&lang=js"

import "./EditHuviring.vue?vue&type=style&index=0&id=2cee6809&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cee6809"]])

export default __exports__